
import { useState } from 'react';

export default function FloatingButtons() {
  const phoneNumber = '34932932913';
  const phoneNumberDisplay = '932 932 913';
  const message = encodeURIComponent('Hola Desguaces Castelldefels, me interesa vender mi coche. ¿Podrían darme una valoración?');
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${message}`;
  const callUrl = `tel:+${phoneNumber}`;

  const [showTooltip, setShowTooltip] = useState<'call' | 'whatsapp' | null>(null);

  return (
    <div className="fixed bottom-4 sm:bottom-6 right-4 sm:right-6 z-50 flex flex-col gap-2 sm:gap-3">
      {/* Botón de llamada */}
      <div className="relative">
        <a
          href={callUrl}
          onMouseEnter={() => setShowTooltip('call')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-600 hover:bg-teal-700 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
          aria-label="Llamar por teléfono"
        >
          <i className="ri-phone-fill text-xl sm:text-2xl"></i>
        </a>
        {showTooltip === 'call' && (
          <div className="hidden sm:block absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-lg">
            Llamar: {phoneNumberDisplay}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-gray-900 rotate-45"></div>
          </div>
        )}
      </div>

      {/* Botón de WhatsApp */}
      <div className="relative">
        <a
          href={whatsappUrl}
          target="_blank"
          rel="nofollow noopener noreferrer"
          onMouseEnter={() => setShowTooltip('whatsapp')}
          onMouseLeave={() => setShowTooltip(null)}
          className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 cursor-pointer"
          aria-label="Contactar por WhatsApp"
        >
          <i className="ri-whatsapp-line text-2xl sm:text-3xl"></i>
          <span className="absolute -top-1 sm:-top-2 -right-0.5 sm:-right-1 w-4 h-4 sm:w-5 sm:h-5 flex items-center justify-center bg-orange-500 text-white text-[10px] sm:text-xs font-bold rounded-full animate-pulse">
            1
          </span>
        </a>
        {showTooltip === 'whatsapp' && (
          <div className="hidden sm:block absolute right-16 top-1/2 -translate-y-1/2 bg-gray-900 text-white text-sm px-3 py-2 rounded-lg whitespace-nowrap shadow-lg">
            WhatsApp: {phoneNumberDisplay}
            <div className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-1 w-2 h-2 bg-gray-900 rotate-45"></div>
          </div>
        )}
      </div>
    </div>
  );
}
